import { render, staticRenderFns } from "./LocationUpdate.vue?vue&type=template&id=6054bbe1&scoped=true"
import script from "./LocationUpdate.vue?vue&type=script&lang=js"
export * from "./LocationUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6054bbe1",
  null
  
)

export default component.exports